import React, { useEffect, useRef, useState } from 'react';
import { Picker } from 'emoji-mart';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import data from '@emoji-mart/data';

import { findPosition } from '../context-menu/actions';
import { useChatBodyContext } from 'widget/content/chat/chat-body/chat-body-context';
import { useMsgContext } from '../msg-context';
import { useOnClickOutside } from 'widget/hooks';
import { useWidgetContext } from 'widget/widget-context';
import * as Env from 'widget/env';

interface Emoji {
  native: string;
}

interface TriggerPostion {
  left: number;
  top: number;
}

interface Position {
  top: number;
  left: number;
}

interface ReactionPicker {
  isReactionPickerActive: boolean;
  setIsReactionPickerActive: Env.SetState<boolean>;
  triggerPosition: TriggerPostion | undefined;
}

const ReactionPicker = ({
  isReactionPickerActive,
  setIsReactionPickerActive,
  triggerPosition,
}: ReactionPicker) => {
  const { widget } = useWidgetContext();
  const { sendReaction } = useChatBodyContext();
  const { msg } = useMsgContext();

  const [position, setPosition] = useState<Position>();

  const { i18n } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const targetRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(targetRef, () => setIsReactionPickerActive(false));

  useEffect(() => {
    if (!isReactionPickerActive) return;

    const res = findPosition(targetRef, { containerRef, triggerPosition });
    setPosition(res);
  }, [isReactionPickerActive]);

  const handleEmojiSelect = (emoji: Emoji) => {
    setIsReactionPickerActive(false);
    sendReaction(msg.id, emoji.native);
  };

  useEffect(() => {
    // eslint-disable-next-line
    const trans = require(
      `@emoji-mart/data/i18n/${i18n.resolvedLanguage}.json`,
    );

    new Picker({
      data,
      dynamicWidth: true,
      i18n: trans,
      onEmojiSelect: handleEmojiSelect,
      previewPosition: 'none',
      ref: targetRef,
      searchPosition: 'none',
      skin: '1',
      theme: widget.theme,
    });
  }, []);

  const left = position?.left ? position.left - 8 : undefined;

  return (
    <div
      className={cn('whatcrm-widget-reaction-picker', {
        'whatcrm-widget-reaction-picker_active': isReactionPickerActive,
      })}
      ref={containerRef}
    >
      <div
        className="whatcrm-widget-reaction-picker__mart"
        ref={targetRef}
        style={{ ...position, left }}
      />
    </div>
  );
};

export default ReactionPicker;
